import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { createLocation } from 'history';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
const useRouterProps = ({
  to = '',
  replace,
  onClick
}) => {
  const history = useHistory();
  const handleClick = useCallback(e => {
    callIfPossible(onClick, e);
    if (e.defaultPrevented) {
      return;
    }
    if (e && !e.metaKey) {
      e.preventDefault();
      if (replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    }
  }, [history, onClick, replace, to]);
  const href = useMemo(() => {
    const location = typeof to === 'string' || to === null ? createLocation(to || '', null, undefined, history.location) : to;
    return history.createHref(location);
  }, [history, to]);
  return useMemo(() => {
    return {
      onClick: handleClick,
      href
    };
  }, [handleClick, href]);
};
export default useRouterProps;